<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import { useCurrentTime } from '../composables/use-current-time.hook'

defineOptions({
  name: 'CurrentTime',
})

const {
  refDate,
  refTime,
} = useCurrentTime()
</script>

<template>
  <div class="time">
    <AppText name="body1">
      {{ refDate }}
    </AppText>
    <AppText name="body1">
      {{ refTime }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./CurrentTime.scss" />
